import { createSlice } from '@reduxjs/toolkit';

export const TipoNovedadSlice = createSlice({
  name: 'tiponovedad',
  initialState: {
    tiponovedades_list: [],
    tiponovedad: {},
    tiponovedades_select: [],
  },
  reducers: {
    setTipoNovedadesRedux: (state, { payload }) => {
      state.tiponovedades_list = payload;
    },
    storeTipoNovedadRedux: (state, { payload }) => {
      state.tiponovedad = payload;
    },
    storeTipoNovedadSelectRedux: (state, { payload }) => {
      state.tiponovedades_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTipoNovedadesRedux, storeTipoNovedadRedux, storeTipoNovedadSelectRedux } =
  TipoNovedadSlice.actions;
